export default __webpack_public_path__ + "static/media/GoodMannerInPublic_12.69733248.png";